import React, { useState } from 'react';
import styled from 'astroturf/react';
import { SuggestionReason } from 'js/social/suggestions/SuggestionReason';
import AvatarBase from 'js/social/shared/Avatar';
import { Body as BodyBase } from 'js/design_system/Body';
import { FollowActionButton as FollowActionButtonBase } from 'js/social/shared/FollowActionButton';
import { createUserFollowing } from 'js/social/api/user_following_api';
import { SuggestionMetadata } from 'js/social/shared/types';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import _FollowActionButton from "BulkFollowSuggestion-FollowActionButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/big_cards/BulkFollowSuggestion.tsx?styleId=FollowActionButton";
import _SuggestionReasonContainer from "BulkFollowSuggestion-SuggestionReasonContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/big_cards/BulkFollowSuggestion.tsx?styleId=SuggestionReasonContainer";
import _ProfileRow from "BulkFollowSuggestion-ProfileRow.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/big_cards/BulkFollowSuggestion.tsx?styleId=ProfileRow";
import _FollowSuggestionItem from "BulkFollowSuggestion-FollowSuggestionItem.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/big_cards/BulkFollowSuggestion.tsx?styleId=FollowSuggestionItem";
import _Avatar from "BulkFollowSuggestion-Avatar.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/big_cards/BulkFollowSuggestion.tsx?styleId=Avatar";
import _ProfileText from "BulkFollowSuggestion-ProfileText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/big_cards/BulkFollowSuggestion.tsx?styleId=ProfileText";
import _SuggestionContainer from "BulkFollowSuggestion-SuggestionContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/big_cards/BulkFollowSuggestion.tsx?styleId=SuggestionContainer";
import _UserInfo from "BulkFollowSuggestion-UserInfo.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/big_cards/BulkFollowSuggestion.tsx?styleId=UserInfo";


export type FollowSuggestion = {
  id: number;
  displayName?: string | null;
  photoUrl: string;
  universityName?: string;
  departmentName?: string;
  suggestionReason?: {
    sources: Array<string>;
    metadata: SuggestionMetadata;
  };
  following?: boolean;
};

type Props = {
  followableUser: FollowSuggestion;
  onFollow: () => void;
  index: number;
  followingSource: string;
  impressionSource?: string; // If present, log impressions of follow buttons
  topic?: {
    name: string;
    score?: number;
  };
  following?: boolean;
};

const FollowActionButton = /*#__PURE__*/styled(FollowActionButtonBase, null, {
  displayName: "FollowActionButton",
  styles: _FollowActionButton
});

const SuggestionReasonContainer = /*#__PURE__*/styled("div", null, {
  displayName: "SuggestionReasonContainer",
  styles: _SuggestionReasonContainer
});

const ProfileRow = /*#__PURE__*/styled("div", null, {
  displayName: "ProfileRow",
  styles: _ProfileRow
});

const FollowSuggestionItem = /*#__PURE__*/styled("div", null, {
  displayName: "FollowSuggestionItem",
  styles: _FollowSuggestionItem
});

const Avatar = /*#__PURE__*/styled(AvatarBase, null, {
  displayName: "Avatar",
  styles: _Avatar
});

const ProfileText = /*#__PURE__*/styled("div", null, {
  displayName: "ProfileText",
  styles: _ProfileText
});

const SuggestionContainer = /*#__PURE__*/styled("div", null, {
  displayName: "SuggestionContainer",
  styles: _SuggestionContainer
});

const UserInfo = /*#__PURE__*/styled(BodyBase, null, {
  displayName: "UserInfo",
  styles: _UserInfo
});

const BulkFollowSuggestion = ({
  followableUser,
  onFollow,
  index,
  followingSource,
  impressionSource = '',
  topic,
  following = false,
}: Props) => {
  const [follows, setFollows] = useState(following);
  const followSourceDetail =
    followableUser.suggestionReason !== undefined
      ? {
          suggestion_reason: followableUser.suggestionReason.sources[0],
        }
      : topic !== undefined
        ? {
            topic: topic?.name ?? '',
            topic_score: topic?.score ?? 0,
            individual_follow: 'true',
          }
        : {};
  const follow = async () => {
    await createUserFollowing(
      followableUser.id,
      followingSource,
      followSourceDetail,
    );
    setFollows(true);
    onFollow();
  };

  return (
    <FollowSuggestionItem
      suggested={followableUser.suggestionReason !== undefined}
    >
      <SuggestionContainer>
        <ProfileRow>
          <Avatar
            fullName={followableUser?.displayName || ''}
            photoUrl={followableUser.photoUrl}
          />

          <ProfileText>
            <UserInfo bold>{followableUser.displayName}</UserInfo>
            {followableUser.universityName && (
              <UserInfo size="sm">{followableUser.universityName}</UserInfo>
            )}
            {followableUser.departmentName && (
              <UserInfo size="sm">{followableUser.departmentName}</UserInfo>
            )}
          </ProfileText>
        </ProfileRow>
        {followableUser.suggestionReason && (
          <SuggestionReasonContainer>
            <SuggestionReason
              source={followableUser.suggestionReason.sources[0]}
              metadata={followableUser.suggestionReason.metadata}
              style={{ margin: 0 }}
            />
          </SuggestionReasonContainer>
        )}
      </SuggestionContainer>

      <ImpressionWatcher
        active={!!impressionSource}
        source={impressionSource}
        extra={{
          modalIdx: index,
          ...followSourceDetail,
        }}
      >
        <FollowActionButton
          size="xs"
          variant="inverse"
          userId={followableUser.id}
          follows={follows}
          onFollow={follow}
          alwaysShowFollowButton
        >
          Follow
        </FollowActionButton>
      </ImpressionWatcher>
    </FollowSuggestionItem>
  );
};

export default BulkFollowSuggestion;
